import React from "react";
import { useParams } from "@remix-run/react";
import { IconArrowRight, IconBrandFigma } from "@tabler/icons-react";

export function Banner() {
  const { technology } = useParams();

  const getBannerText = (tech: string | undefined) => {
    switch (tech) {
      case "react":
        return "React";
      case "vue":
        return "Vue";
      case "angular":
        return "Angular";
      case "svelte":
        return "Svelte";
      case "solidjs":
        return "SolidJS";
      case "qwik":
        return "Qwik";
      case "javascript":
        return "JavaScript";
      case "typescript":
        return "TypeScript";
      case "ai":
      default:
        return "code";
    }
  };

  const bannerText = getBannerText(technology);

  return (
    <a
      target="_blank"
      href="https://www.builder.io/m/design-to-code"
      rel="noreferrer"
      className="bg-primary text-primary-foreground p-3 max-md:p-2"
      onClick={() => {
        window.gtag("event", "banner_click", {
          banner_text: bannerText,
        });
      }}
    >
      <div className="container mx-auto text-center">
        <p className="font-semibold flex items-center gap-2 justify-center max-md:text-sm">
          Convert{" "}
          <img
            src="https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2Fe730c2a3fc4c4be196631093b3434624"
            alt="Figma logo"
            className="w-5 h-5 max-md:w-4 max-md:h-4 object-contain"
          />{" "}
          to {bannerText} with AI <IconArrowRight size={18} />
        </p>
      </div>
    </a>
  );
}
